import { api } from '@api/api2';

export const getEmployees = () =>
  api.v1('get', 'employee/get-simple-list', { per_page: 999999 });
